import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mifosx-manage-jobs',
  templateUrl: './manage-jobs.component.html',
  styleUrls: ['./manage-jobs.component.scss']
})
export class ManageJobsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
